module.exports = __webpack_public_path__ + "static/img/copy.837e5ab8.svg";